module.exports = __webpack_public_path__ + "media/images/copy_icon-26de71dc.svg";